<script setup lang="ts">
import { HugeIcon, type Icon } from '@teachino/shared-design-system';

const FEATURE_ICON_SIZE = 16;

defineProps<{
  icon: Icon;
  title: string;
  description: string;
}>();
</script>

<template>
  <div
    class="flex items-start gap-2.5 rounded-lg border border-slate-200/80 bg-slate-50/60 p-3"
  >
    <div
      class="border-primary-100 text-primary-600 flex h-8 w-8 shrink-0 items-center justify-center rounded-md border bg-white"
    >
      <HugeIcon :icon="icon" :size="FEATURE_ICON_SIZE" />
    </div>
    <div class="min-w-0 flex-1 space-y-0.5">
      <p class="text-sm leading-snug font-medium text-slate-900">{{ title }}</p>
      <p class="text-xs leading-snug text-slate-600">{{ description }}</p>
    </div>
  </div>
</template>
